export const APP_DEFINED_PAGES = [
    'settings'
];